function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.28 0V0.72V2.89828C9.51008 3.26369 3.26369 9.51008 2.89828 17.28H0.72H0V18.72H0.72H2.89828C3.26369 26.4899 9.51008 32.7363 17.28 33.1017V35.28V36H18.72V35.28V33.1017C26.4899 32.7363 32.7363 26.4899 33.1017 18.72H35.28H36V17.28H35.28H33.1017C32.7363 9.51008 26.4899 3.26369 18.72 2.89828V0.72V0H17.28ZM17.28 4.35656V6.48V7.2H18.72V6.48V4.35656C25.7062 4.71982 31.2802 10.2938 31.6434 17.28H29.52H28.8V18.72H29.52H31.6434C31.2802 25.7062 25.7062 31.2802 18.72 31.6434V29.52V28.8H17.28V29.52V31.6434C10.2938 31.2802 4.71982 25.7062 4.35656 18.72H6.48H7.2V17.28H6.48H4.35656C4.71982 10.2938 10.2938 4.71982 17.28 4.35656Z",
  fill: "#9499A2"
});

var SvgIcoTarget = function SvgIcoTarget(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoTarget, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_target.0bb991d4.svg";
export { ForwardRef as ReactComponent };